<template>
  <div>
    <v-alert v-if="!temRegistros" dense outlined type="info" class="mt-3">
      Nenhuma registro encontrada.
    </v-alert>

    <section v-for="grupo in grupos" :key="grupo.data" class="mb-5">
      <div class="d-flex justify-space-between align-center mb-2">
        <div class="font-weight-bold">{{ grupo.titulo }}</div>
        <v-btn
          v-if="modoAdmin"
          x-small
          outlined
          color="primary"
          @click="$emit('nova-batida', grupo.data)"
        >
          <v-icon left x-small>mdi-plus</v-icon>
          Nova batida
        </v-btn>
      </div>
      <horario-batida-card
        v-for="item in grupo.items"
        :key="item.id"
        :item="item"
        :modo-admin="modoAdmin"
        :comprovante-service="comprovanteService"
        @editar="$emit('editar-batida', $event)"
        @excluir="$emit('excluir-batida', $event)"
      />
    </section>
  </div>
</template>

<script>
export default {
  name: "HorarioListaAgrupada",
  props: {
    registros: {
      type: [Array, Object],
      default: () => [],
    },
    modoAdmin: {
      type: Boolean,
      default: false,
    },
    comprovanteService: {
      type: String,
      default: "instrutor",
    },
  },
  computed: {
    grupos() {
      if (Array.isArray(this.registros)) {
        return this.registros.length
          ? [
              {
                data: this.registros[0].data,
                titulo: `${this.registros[0].data_formatada} - ${this.registros[0].dia_semana}`,
                items: this.registros,
              },
            ]
          : [];
      }

      return Object.keys(this.registros || {})
        .sort()
        .reverse()
        .map((data) => {
          const items = this.registros[data] || [];
          const primeiro = items[0] || {};
          return {
            data,
            titulo: primeiro.data_formatada
              ? `${primeiro.data_formatada} - ${primeiro.dia_semana}`
              : data,
            items,
          };
        });
    },
    temRegistros() {
      return this.grupos.some((grupo) => grupo.items.length > 0);
    },
  },
};
</script>
